import ImageCarouselSetting from './ImageCarouselSetting';
import PosterCarouselSetting from './PosterCarouselSetting';

export { ImageCarouselSetting, PosterCarouselSetting };
